import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@app/core';
import * as amplitude from 'amplitude-js';

@Component({
  selector: 'app-fiat-deposit',
  template: `
    <form [formGroup]="form" (ngSubmit)="submit($event)">
      <h5>FIAT Deposit</h5>
      <div class="columns">
        <div class="form-group">
          <label>Amount to deposit</label>
          <input
            type="number"
            formControlName="amount"
            class="input"
            maxlength="25"
            name="amount-to-withdraw"
            required
            placeholder="00.00"
          />
        </div>
        <div class="form-group">
          <label>Currency</label>
          <app-form-select [options]="currencies" formControlName="currency"></app-form-select>
        </div>
      </div>

      <p>If asked for ETH wallet please make sure you provide this one:</p>

      <div class="deposit-address-wrap">
        <div class="address" [cbContent]="address" ngxClipboard>{{ address }}</div>
        <div class="deposit-right-flex">
          <button type="button" class="copy-address" [disabled]="!address" ngxClipboard [cbContent]="address">
            <i class="fal fa-copy"></i>
          </button>
        </div>
      </div>

      <button class="btn btn-primary" [disabled]="form.invalid" type="submit" ngxClipboard [cbContent]="address">
        Next step
      </button>

      <a [href]="url" target="_blank" #anchorElement class="anchor">Open in new tab.</a>

      <p>
        By clicking "Next step" you will be redirected to our partners (Changelly) website where you will be able to
        purchase <i>DAI</i> token.
      </p>
      <p><i>DAI</i> balance will be visible as USD in our platform.</p>
      <p><i>Changelly</i> may ask KYC verification before making deposits.</p>

      <app-deposit-bonus-notice></app-deposit-bonus-notice>
    </form>
  `,
  styleUrls: ['./fiat-deposit.template.scss'],
})
export class FiatDepositComponent implements OnInit, OnDestroy, OnChanges {
  public form: FormGroup;
  subs = new Subscription();

  public url: SafeUrl;

  currencies = [{ option: 'usd', value: 'USD' }, { option: 'eur', value: 'EUR' }, { option: 'gbp', value: 'GBP' }];

  @Input('address') address: string;

  @ViewChild('anchorElement') anchorElement: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private auth: AuthenticationService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      amount: [50, [Validators.required, Validators.min(50)]],
      currency: ['usd', [Validators.required]],
    });

    this.subs.add(
      this.form.valueChanges.subscribe(_ => {
        this.generateUrl();
      })
    );

    this.generateUrl();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.generateUrl();
  }

  generateUrl(): void {
    if (!this.form) {
      return;
    }
    const { currency, amount } = this.form.value;
    const address = this.address;
    let email = '';
    if (this.auth.userInfo) {
      email = this.auth.userInfo.email;
    }
    this.url = this.sanitizer.bypassSecurityTrustUrl(
      // tslint:disable-next-line:max-line-length
      `https://widget.changelly.com/?currencies=dai&from=${currency}&to=dai&amount=${amount}&address=${address}&fiat=true&fixedTo=true&theme=aqua&merchant_id=${
        environment.changellyMerchantId
      }&email=${email}`
    );
  }

  public submit($event: any) {
    $event.preventDefault();
    amplitude.getInstance().logEvent('FIAT - Next Step');
    try {
      this.anchorElement.nativeElement.click();
    } catch (e) {
      this.document.location.href = this.url.toString();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/fiat-deposit.component.ts